import { styled, alpha } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

const SpecSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: '#E78271',
      '&:hover': {
        backgroundColor: alpha('#E78271', theme.palette.action.hoverOpacity),
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#E78271',
    },
  }));

  export default SpecSwitch;